import React from "react";
// @material-ui/core components
import { useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
// @material-ui/icons components
import Backup from "@material-ui/icons/Backup";
import Brush from "@material-ui/icons/Brush";
import Notes from "@material-ui/icons/Notes";

// core components
import boxShadows from "assets/theme/box-shadow.js";

function CardPricingGradient() {
  const theme = useTheme();

  return (
    <>
      <Card
        sx={{
          textAlign: "center",
          marginBottom: "1.5rem",
          borderRadius: ".375rem!important",
          background:
            "linear-gradient(87deg," +
            theme.palette.success.main +
            ",#2dcecc)!important",
          boxShadow: boxShadows.boxShadowLg,
          [theme.breakpoints.up("md")]: {
            zIndex: 1,
            transform: "scale(1.1)",
          },
        }}
      >
        <CardHeader
          title="Alpha pack"
          sx={{ background: "inherit" }}
          titleTypographyProps={{
            sx: {
              letterSpacing: ".0625rem",
              textTransform: "uppercase",
              color: theme.palette.white.main,
              paddingTop: "1rem",
              paddingBottom: "1rem",
              marginBottom: "0",
            },
            component: "h4",
            variant: "h4",
          }}
        ></CardHeader>
        <CardContent
          sx={{
            [theme.breakpoints.up("md")]: {
              paddingLeft: "6rem",
              paddingRight: "6rem",
            },
          }}
        >
          <Box
            sx={{
              color: theme.palette.white.main,
              fontSize: "3.3rem",
              fontWeight: 600,
              lineHeight: 1.5,
            }}
          >
            $199
          </Box>
          <Box component="span" sx={{ color: theme.palette.white.main }}>
            per application
          </Box>
          <Box component="ul" sx={{ paddingLeft: "0", margin: "1.5rem 0" }}>
            <Box
              component="li"
              sx={{
                paddingTop: ".5rem",
                paddingBottom: ".5rem",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  padding: "12px",
                  textAlign: "center",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "1.25rem",
                  height: "1.25rem",
                  boxShadow: boxShadows.boxShadow,
                  color: theme.palette.gray[600],
                  borderRadius: "50%",
                  background: theme.palette.white.main,
                }}
              >
                <Notes />
              </Box>
              <Box
                sx={{ paddingLeft: ".5rem", color: theme.palette.white.main }}
              >
                Complete documentation
              </Box>
            </Box>
            <Box
              component="li"
              sx={{
                paddingTop: ".5rem",
                paddingBottom: ".5rem",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  padding: "12px",
                  textAlign: "center",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "1.25rem",
                  height: "1.25rem",
                  boxShadow: boxShadows.boxShadow,
                  color: theme.palette.gray[600],
                  borderRadius: "50%",
                  background: theme.palette.white.main,
                }}
              >
                <Brush />
              </Box>
              <Box
                sx={{ paddingLeft: ".5rem", color: theme.palette.white.main }}
              >
                Working materials in Sketch
              </Box>
            </Box>
            <Box
              component="li"
              sx={{
                paddingTop: ".5rem",
                paddingBottom: ".5rem",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  padding: "12px",
                  textAlign: "center",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "1.25rem",
                  height: "1.25rem",
                  boxShadow: boxShadows.boxShadow,
                  color: theme.palette.gray[600],
                  borderRadius: "50%",
                  background: theme.palette.white.main,
                }}
              >
                <Backup />
              </Box>
              <Box
                sx={{ paddingLeft: ".5rem", color: theme.palette.white.main }}
              >
                2GB cloud storage
              </Box>
            </Box>
          </Box>
          <Box sx={{ marginBottom: "1rem", textAlign: "center" }}>
            <Button variant="neutral" color="dark">
              Start free trial
            </Button>
          </Box>
        </CardContent>
        <CardActions sx={{ justifyContent: "center", background: "inherit" }}>
          <Box
            component="a"
            href="#mui"
            onClick={(e) => e.preventDefault()}
            sx={{
              color: theme.palette.white.main,
              textDecoration: "none",
              backgroundColor: "initial",
              "&:hover": {
                color: theme.palette.gray[100],
              },
            }}
          >
            Contact Sales
          </Box>
        </CardActions>
      </Card>
    </>
  );
}

export default CardPricingGradient;
